import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyBtn", "annualBtn", "price", "period", "badge", "billedNote", "ctaLink", "ctaPlan"]
  static values = { initialPlan: String, monthlyPrice: Number, annualPrice: Number }

  connect() {
    if (this.initialPlanValue === "annual") {
      this.selectAnnual()
    } else {
      this.selectMonthly()
    }
  }

  selectMonthly() {
    this.priceTarget.textContent = `$${this.monthlyPriceValue}`
    this.periodTarget.textContent = "/mo"
    this.billedNoteTarget.classList.add("invisible")

    this.monthlyBtnTarget.classList.add("bg-[var(--color-kova-accent)]", "text-white")
    this.monthlyBtnTarget.classList.remove("text-[var(--color-kova-muted)]")

    this.annualBtnTarget.classList.remove("bg-[var(--color-kova-accent)]", "text-white")
    this.annualBtnTarget.classList.add("text-[var(--color-kova-muted)]")

    this.#updatePlan("monthly")
  }

  selectAnnual() {
    this.priceTarget.textContent = `$${this.annualPriceValue}`
    this.periodTarget.textContent = "/mo"
    this.billedNoteTarget.classList.remove("invisible")

    this.annualBtnTarget.classList.add("bg-[var(--color-kova-accent)]", "text-white")
    this.annualBtnTarget.classList.remove("text-[var(--color-kova-muted)]")

    this.monthlyBtnTarget.classList.remove("bg-[var(--color-kova-accent)]", "text-white")
    this.monthlyBtnTarget.classList.add("text-[var(--color-kova-muted)]")

    this.#updatePlan("annual")
  }

  #updatePlan(plan) {
    if (this.hasCtaLinkTarget) {
      const url = new URL(this.ctaLinkTarget.href)
      url.searchParams.set("plan", plan)
      this.ctaLinkTarget.href = url.toString()
    }
    if (this.hasCtaPlanTarget) {
      this.ctaPlanTarget.value = plan
    }
  }
}
